<template>
  <v-card v-show="!tempIsPageLoading">
    <SearchTools
      :searchQuery.sync="searchQuery"
      @do-search="doSearch"
      @do-clear="doClear"
    >
      <template v-slot:prepend>
        <b-col :sm="3">
          <FormDatepickerBase
            :type="'text'"
            :clearable="true"
            :max="maxDate"
            :i18n="{
              label: 'FROM',
              placeholder: $t('FROM')
            }"
            :date.sync="filters.fromDate"
          ></FormDatepickerBase>
        </b-col>

        <b-col :sm="3">
          <FormDatepickerBase
            :type="'text'"
            :clearable="true"
            :max="maxDate"
            :i18n="{
              label: 'TO',
              placeholder: $t('TO')
            }"
            :date.sync="filters.toDate"
          ></FormDatepickerBase>
        </b-col>
        <b-col :sm="3" v-if="!tempIsPageLoading">
          <v-select
            :items="yesNoOptions"
            :label="$t('ACCOUNTED')"
            item-text="text"
            item-value="value"
            hide-details
            clearable
            v-model="filters.isAccounted"
            @click:clear="clearFilter('isAccounted')"
          ></v-select>
        </b-col>
        <b-col :lg="3" :md="12" v-if="!tempIsPageLoading && _.size(stores) > 0">
          <v-autocomplete
            hide-details
            v-if="_.size(stores) > 0"
            :items="stores"
            :label="$t('STORE')"
            item-text="name"
            item-value="id"
            clearable
            v-model="filters.storeId"
          ></v-autocomplete>
        </b-col>
      </template>
    </SearchTools>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      :options.sync="options"
      :items-per-page="totalItems"
      :server-items-length="totalItems"
      sort-by="issueDate"
      sort-desc="true"
      :loading="isLoadingStock"
      loading-text="Loading... Please wait"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: rowsPerPageItems,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        itemsPerPageText: $t('ITEMS_PER_PAGE_TEXT')
      }"
      @update:options="getDataFromApi()"
      class="elevation-1"
    >
      <template v-slot:item.storeName="{ item }">
        ({{ item.storeCode }}) {{ item.storeName }}
      </template>
      <template v-slot:item.regAt="{ item }">
        {{ item.regAt | formatDateTime }}
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="container-fluid" v-if="item.regAt == null">
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <v-dialog
                v-model="dialogEdit"
                max-width="1024px"
                :retain-focus="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-1"
                    v-bind="attrs"
                    v-on="on"
                    fab
                    dark
                    x-small
                    @click="edit(item)"
                  >
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{
                      $t("INVOICE") +
                        " - " +
                        $t("EDIT") +
                        " : " +
                        editForm.companyName
                    }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editForm.companyName"
                            :label="$t('COMPANY_NAME')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editForm.invoiceNumber"
                            :label="$t('INVOICE_NUMBER')"
                          ></v-text-field
                        ></v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editForm.vatNumber"
                            :label="$t('VAT_NUMBER')"
                          ></v-text-field
                        ></v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editForm.registrationNumber"
                            :label="$t('REGISTRATION_NUMBER')"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="update()">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ searchQuery }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
    <v-btn
      color="btn-success"
      class="btn btn-light-success font-weight-bolder mr-1 mt-3 mb-2 ml-1"
      @click="getEchoInvoicesExcel()"
    >
      <i class="flaticon-download"></i>
      {{ $t("DOWNLOAD_INVOICES_EXCEL") }}
    </v-btn>
  </v-card>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
</style>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { mapGetters } from "vuex";
import SearchTools from "@/core/components/table/SearchTools.vue";
import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";

//Stock Module
import {
  FETCH_ECHO_INVOICES,
  UPDATE_ECHO_INVOICE,
  ECHO_INVOICES_DOWNLOAD_EXCEL
} from "@/modules/stock/store/stock.module";

import { FETCH_STORES_BASIC } from "@/core/services/store/shared_store.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";
import i18n from "@/core/plugins/vue-i18n";

import _ from "lodash";
import moment from "moment";
export default {
  name: "EchoInvoiceListTable",
  mixins: [permissionMixin],
  props: {
    isPageLoading: {
      type: Boolean,
      default: true
    },
    firstLoader: {
      type: Boolean,
      default: true
    },
    isPreviewMode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      items: [],
      stores: [],
      suppliers: [],
      forwarders: [],
      contractors: [],
      customs: [],
      clients: [],
      totalItems: 100,
      dialogEdit: false,
      searchQuery: "",
      editForm: {
        id: "",
        companyName: "",
        invoiceNumber: "",
        vatNumber: "",
        registrationNumber: ""
      },
      filters: {
        storeId: null,
        fromDate: null,
        toDate: null,
        isAccounted: null
      },
      options: {
        descending: true,
        page: 1,
        itemsPerPage: 10,
        totalItems: 100
      },
      yesNoOptions: [
        {
          value: "1",
          text: i18n.t("YES")
        },
        {
          value: "0",
          text: i18n.t("NO")
        }
      ],
      rowsPerPageItems: [10, 20, 30, 40, 50],
      columns: {},
      cancelSource: null,
      selectedItemId: null,
      headers: [
        {
          text: this.$t("ID"),
          value: "id"
        },
        {
          text: this.$t("ORDER"),
          value: "orderId"
        },
        {
          text: this.$t("STORE"),
          value: "storeName",
          sortable: false
        },
        {
          text: this.$t("FOR_DATE"),
          value: "invoiceDate"
        },
        {
          text: this.$t("COMPANY_NAME"),
          value: "companyName"
        },
        {
          text: this.$t("INVOICE_NUMBER"),
          value: "invoiceNumber"
        },
        {
          text: this.$t("VAT_NUMBER"),
          value: "vatNumber"
        },
        {
          text: this.$t("REGISTRATION_NUMBER"),
          value: "registrationNumber"
        },
        {
          text: this.$t("TOTAL_NET_VALUE9"),
          align: "right",
          value: "totalNetValue9"
        },
        {
          text: this.$t("TOTAL_VAT_VALUE9"),
          align: "right",
          value: "totalVatValue9"
        },
        {
          text: this.$t("TOTAL_NET_VALUE20"),
          align: "right",
          value: "totalNetValue20"
        },
        {
          text: this.$t("TOTAL_VAT_VALUE20"),
          align: "right",
          value: "totalVatValue20"
        },
        {
          text: this.$t("TOTAL_INVOICE_GROSS_VALUE"),
          align: "right",
          value: "totalInvoiceGrossValue"
        },
        {
          align: "right",
          text: this.$t("ACCOUNTED"),
          value: "regAt",
          sortable: false,
          width: "10%"
        },
        {
          align: "right",
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "100px"
        }
      ]
    };
  },
  components: {
    SearchTools,
    FormDatepickerBase
  },
  watch: {
    storesParams(value) {
      let vm = this;
      vm.filters.storeId = null;
      vm.getStores();
    },
    dialogEdit(val) {
      val || this.close();
    }
  },
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Echo Invoices", route: { name: "echo-invoices-list" } },
      { title: "Echo Invoice List" }
    ]);

    vm.getStores();
  },
  computed: {
    ...mapGetters([
      "getItems",
      "isLoadingStock",
      "isLoadingSharedStore",
      "currentUser"
    ]),
    tempFirstLoader: {
      get: function() {
        return this.firstLoader;
      },
      set: function(newValue) {
        this.$emit("update:firstLoader", newValue);
      }
    },
    tempIsPageLoading: {
      get: function() {
        return this.isPageLoading;
      },
      set: function(newValue) {
        this.$emit("update:isPageLoading", newValue);
      }
    },
    params() {
      return {
        ...this.options,
        query: this.searchQuery,
        fromDate: this.filters.fromDate,
        storeId: this.filters.storeId,
        toDate: this.filters.toDate,
        isAccounted: this.filters.isAccounted
      };
    },
    storesParams() {
      let storesParams = {};
      return storesParams;
    },
    tableHeaders() {
      let vm = this;

      return vm.headers;
    },
    maxDate() {
      return moment().format("YYYY-MM-DD");
    }
  },
  methods: {
    close() {
      let vm = this;
      vm.dialogEdit = false;
    },
    edit(item) {
      this.editForm = Object.assign({}, item);
      this.dialogEdit = true;
    },
    update() {
      let vm = this;
      let id = vm.editForm.id;
      let payload = {
        companyName: vm.editForm.companyName,
        invoiceNumber: vm.editForm.invoiceNumber,
        vatNumber: vm.editForm.vatNumber,
        registrationNumber: vm.editForm.registrationNumber
      };

      this.$store
        .dispatch(UPDATE_ECHO_INVOICE, { id: id, payload: payload })
        .then(data => {
          vm.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });
          vm.$nextTick(function() {
            vm.close();
            vm.doSearch();
          });
        })
        .catch(response => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Not Found"
            });
            vm.close();
          }
          if (response.status === 422) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: response.data.message
            });
          }
        });
    },
    clearFilter(key) {
      let vm = this;
      vm.$nextTick(function() {
        this.$set(vm.filters, key, null);
      });
    },
    cancelRequest() {
      //Axios cancelSource to stop current search if new value is entered
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
      }
    },
    doSearch() {
      let vm = this;
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    doClear() {
      let vm = this;
      vm.searchQuery = "";
      vm.filters.storeId = null;
      vm.filters.isAccounted = null;
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    getDataFromApi() {
      let vm = this;
      //copy current params to modify
      let params = this.params;

      params.length = params.itemsPerPage; //set how many records to fecth per page
      params.start =
        params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1); //set offset
      let apiParams = vm.transformUrlParams(params);
      vm.$store
        .dispatch(FETCH_ECHO_INVOICES, apiParams)
        .then(data => {
          vm.tempFirstLoader = false;
          vm.$nextTick(function() {
            vm.items = data.data.items;
            vm.totalItems = data.data.totalItemsCount;
            if (vm.tempIsPageLoading == true) {
              vm.tempIsPageLoading = false;
            }
          });
        })
        .catch(response => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "stock-invoices-list" });
          }
        });
    },
    getEchoInvoicesExcel() {
      let vm = this;

      let params = this.params;
      params.length = params.itemsPerPage; //set how many records to fecth per page
      params.start =
        params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1); //set offset
      let apiParams = vm.transformUrlParams(params);

      this.$store
        .dispatch(ECHO_INVOICES_DOWNLOAD_EXCEL, apiParams)
        .then(data => {
          vm.firstLoader = false;
          vm.$nextTick(function() {
            let blob = new Blob([data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Echo-Invoices-Excel.xlsx";
            link.click();
            link.remove();
            if (vm.isPageLoading == true || vm.isXmlMzLoading == true) {
              vm.isPageLoading = false;
            }
          });
        })
        .catch(response => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Not Found"
            });
          }
        });
    },
    getStores() {
      let vm = this;
      let params = this.storesParams;
      let apiParams = vm.transformUrlParams(params);
      this.$store
        .dispatch(FETCH_STORES_BASIC, apiParams)
        .then(data => {
          this.$set(vm, "stores", data.data);
        })
        .catch(response => {
          console.log(response);
        });
    },
    getIconOperator(operator) {
      if (operator == "+") {
        return "flaticon2-plus text-success";
      }

      if (operator == "-") {
        return "flaticon2-line text-danger";
      }
      return "";
    },
    transformUrlParams(params) {
      let apiParams =
        "?" +
        Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
      return apiParams;
    }
  }
};
</script>
